const localStorageAvailable = () => {
  try {
    if (globalThis.localStorage) return true
  } catch {
    return false
  }
}

const safeLocalStorage = {
  get: (key) => {
    if (localStorageAvailable()) return localStorage.getItem(key)
  },
  remove: (key) => {
    try {
      if (localStorageAvailable()) {
        return localStorage.removeItem(key)
      }
    } catch {
      console.error('Error removing item from localStorage:', key)
    }
  },
  set: (key, value) => {
    try {
      // if storage is full, an error will be thrown when setting,
      // so it needs to be caught
      if (localStorageAvailable()) {
        return localStorage.setItem(key, value)
      }
    } catch {
      console.error('Error setting item in localStorage:', key)
    }
  },
}

export default safeLocalStorage
